import { styled } from '../../../stitches.config';

export const Component = styled('div', {
  display: 'inline-block',
  visibility: 'hidden',
});
